import { render } from "./PayrollSettingLayout.vue?vue&type=template&id=98950576"
import script from "./PayrollSettingLayout.vue?vue&type=script&lang=js"
export * from "./PayrollSettingLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__